import {
  Button,
  Flex,
  Heading,
  Image,
  Stack,
  Text,
  Link,
  useBreakpointValue,
} from '@chakra-ui/react';

export default function SplitScreen() {
  return (
    <Stack minH={'100vh'} direction={{ base: 'column', md: 'row' }}>
      <Flex p={8} flex={1} align={'center'} justify={'center'}>
        <Stack spacing={6} w={'full'} maxW={'lg'}>
          <Heading fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}>
            <Text
              as={'span'}
              position={'relative'}
              _after={{
                content: "''",
                width: 'full',
                height: useBreakpointValue({ base: '20%', md: '30%' }),
                position: 'absolute',
                bottom: 1,
                left: 0,
                bg: 'blue.400',
                zIndex: -1,
              }}>
              UC Berkeley's
            </Text>
            <br />{' '}
            <Text color={'blue.400'} as={'span'}>
              Library Finder
            </Text>{' '}
          </Heading>
          <Text fontSize={{ base: 'md', lg: 'lg' }} color={'gray.500'}>
          An online platform that collects information about libraries across 
          UC Berkeley's campus and recommends you a selection of choices 
          based on your preferences.
          Note: This project is hosted on a free render.com server, so give the backend about 5 minutes to startup!
          </Text>
          <Stack direction={{ base: 'column', md: 'row' }} spacing={4}>
            <Link href='/login'><Button
              rounded={'full'}
              bg={'blue.400'}
              color={'white'}
              _hover={{
                bg: 'blue.500',
              }}>
              Sign up
            </Button></Link>
            <Link href='/libraries'><Button rounded={'full'}>Find my library</Button></Link>
          </Stack>
        </Stack>
      </Flex>
      <Flex flex={1}>
        <Image
          alt={'Login Image'}
          objectFit={'cover'}
          src={
            'https://s.hdnux.com/photos/26/06/56/5794723/4/ratio3x2_2400.jpg'
          }
        />
      </Flex>
    </Stack>
  );
}
